import * as React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';

import { Main } from './details';
import { ZoomIntegration } from './components';

export const Zoom = () => {
  return (
    <>
      <DocumentHead title='Integrations-Zoom ' />
      <PageTemplate
        modal={[]}
        main={
          <Main>
            <ZoomIntegration />
          </Main>
        }
      />
    </>
  );
};
